import { gql } from '@apollo/client'

export const BOOKING_NOTE_MAX_CHARACTERS = 2000

export const BOOKING_NOTES_QUERY = gql`
  query BookingNotes($reservationNumber: String!, $page: Int) {
    bookingNotes(reservationNumber: $reservationNumber, page: $page) {
      canAdd
      canViewTraceDeliveryDetails
      roomNumbers
      notes {
        id
        text
        kind
        state
        createdAt
        roomNumbers
        deliveries {
          roomNumber
          deliveryId
          state
          traceReference
          providerReference
          registeredAt
          failureCode
        }
      }
      page
      hasMore
    }
  }
`

export const ADD_BOOKING_NOTE_MUTATION = gql`
  mutation AddBookingNote(
    $reservationNumber: String!
    $input: AddBookingNoteInput!
  ) {
    addBookingNote(reservationNumber: $reservationNumber, input: $input) {
      id
      text
      kind
      state
      createdAt
      roomNumbers
      deliveries {
        roomNumber
        deliveryId
        state
        traceReference
        providerReference
        registeredAt
        failureCode
      }
    }
  }
`

export interface BookingNote {
  id: string
  text: string
  kind: string
  state: string
  createdAt: string
  roomNumbers: string[]
  deliveries: {
    roomNumber: string
    deliveryId: string
    state: string
    traceReference: number | null
    providerReference?: string | null
    registeredAt?: string | null
    failureCode: string | null
  }[]
}

export interface BookingNotesPage {
  canAdd: boolean
  canViewTraceDeliveryDetails?: boolean
  roomNumbers: string[]
  notes: BookingNote[]
  page: number
  hasMore: boolean
}
